module.exports = __webpack_public_path__ + "img/delete.5c2f7ce5.svg";